import React, { useState, useEffect } from 'react';
import { useSnackbar } from "notistack";
import { useParams } from "react-router-dom";
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Autocomplete, CircularProgress, Box, Tooltip, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { AttachementsUpload } from '../../../../shared_elements/components';
import { addQMEApi, updateQMEApi, reserveAccountApi } from '../apiService';
import { globalPostService, globalPutService, globalGetService } from '../../../../utils/globalApiServices';
import { checkApiStatus } from '../../../../utils';
import { backendDateFormat, fieldDateFormat } from '../../../../constants';
import { PageLoader } from '../../../../shared_elements';
import moment from 'moment';
import { trackActivity } from '../../../../utils/mixpanel';
import { setFileUploadDetails } from '../../../../shared_elements/actions';
import { useDispatch, useSelector } from 'react-redux';
import { formatBytes } from '../../../../utils/fileUpload';
import { regexConstants } from '../../../../constants/regEx';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';

const Qualified_CRU = ({ qmeCRU, modeType, fileUpload, getResponseBack, onOpenAttachments, onToggleModal }) => {
    const dispatch = useDispatch()
    const { leaseSlug } = useParams();
    const { storageDetails } = useSelector((state) => state.leases);
    const params = { leaseSlug: leaseSlug };
    const [error, setError] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState(qmeCRU?.data);
    const { enqueueSnackbar } = useSnackbar()
    const [attachments, setAttachments] = useState([]);
    const [cleared, setCleared] = useState(false);
    const [reserveAccount, setReserveAccount] = useState([])
    const [dropDownloader,setDropDownLoader]=useState(false)

    useEffect(() => {
        getReserveAccountApi()
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);
            return () => clearTimeout(timeout);
        }
        return () => { };
    }, [])

    const handleFileChange = (files) => {
        setAttachments(files);
        dispatch(setFileUploadDetails({ attachments: files }))
    };
    const onFieldChange = (key, value) => {
        setData({ ...data, [key]: value });
        setError((prev) => ({ ...prev, [key]: '' }));
    };

    const getReserveAccountApi = () => {
        setDropDownLoader(true);
        globalGetService(reserveAccountApi(params))
            .then(response => {
                if (checkApiStatus(response)) {
                    setDropDownLoader(false);
                    setReserveAccount(response?.data?.data?.list || []);
                }
                setDropDownLoader(false);
            })
    }

    const onAddEditMember = () => {
        let validationInputs = {};
        validationInputs = {
            reserve_account_id: data?.reserve_account_id ? "" : "Please select Reserve Account",
            qualified_items: data?.qualified_items?.trim() ? "" : "Please enter Qualified Items",
        };

        const validityStartDate = moment(data?.start_date); 
        const validityEndDate = moment(data?.end_date);

        if(data.start_date && !validityStartDate.isValid()) {
            validationInputs.start_date = "Please enter valid Start Date";
        }
        if(data.end_date && !validityEndDate.isValid()) {
            validationInputs.end_date = "Please enter valid End Date";
        }

        let payload = Object.assign({}, data)
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            if (data?.id) {
                globalPutService(updateQMEApi({ ...params, slug: data?.slug }), payload).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(data?.slug,'updated')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Edited', { page_title: `Edit Qualified Maintenance Event`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit Qualified Maintenance Event`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    }
                });
            } else {
                globalPostService(addQMEApi(params), { ...payload, reserve_account_id: { id: payload?.reserve_account_id?.id, name: payload?.reserve_account_id?.name } }).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(response?.data?.data?.slug,'created')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Added', { page_title: `Add Qualified Maintenance Event`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Qualified Maintenance Event`, error_msg: response?.data?.message, item_id: null, payload: data, response: response?.data })
                    }
                });
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Qualified Maintenance Event`, error_msg: validationInputs, })
        }
    };

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Qualified Maintenance Event`, page_type: page_type, })
    }

    return (
        <>
            <Dialog
                // onClose={onToggleModal}
                aria-labelledby="customized-dialog-title"
                className='add-lease-dialog'
                maxWidth='md'
                fullWidth
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography className="dialog-header-title">
                        {modeType === 'add' ? 'Add Qualified Maintenance Events' : modeType === 'edit' ? 'Edit Qualified Maintenance Events' : 'View Qualified Maintenance Events'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                options={reserveAccount || []}
                                disabled={modeType === 'view'}
                                getOptionLabel={(option) => option?.name || ""}
                                noOptionsText={dropDownloader && modeType !== "view" ? "Loading..." : "No Option Available"}
                                value={data?.reserve_account_id || null}
                                onChange={(e, value) => onFieldChange("reserve_account_id", value)}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow>
                                            <TextField
                                                {...params}
                                                label="Reserve Account"
                                                margin='normal'
                                                size='small'
                                                required
                                                error={!!error.reserve_account_id}
                                                helperText={error.reserve_account_id}
                                                slotProps={{
                                                    inputLabel: { shrink: true, }, input: {
                                                        ...params?.InputProps, endAdornment: (<>{dropDownloader && modeType !== "view" && (
                                                            <CircularProgress color="inherit" size={20} />
                                                        )}
                                                            {params?.InputProps?.endAdornment}</>)
                                                    }
                                                }}
                                                disabled={modeType === 'view'}
                                            />
                                        </Tooltip>)
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Validity Start Date"
                                    value={data?.start_date ? moment(data.start_date) : null}
                                    onChange={(data) => onFieldChange("start_date", data ? moment(data).format(backendDateFormat) : null)}
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.start_date || false,
                                            helperText: error.start_date || '',
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("start_date", null);
                                                setCleared(true);
                                            }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Validity End Date"
                                    value={data?.end_date ? moment(data.end_date) : null}
                                    onChange={(data) => onFieldChange("end_date", data ? moment(data).format(backendDateFormat) : null)}
                                    minDate={data?.start_date ? moment(data.start_date) : null}
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.end_date || false,
                                            helperText: error.end_date || '',
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("end_date", null);
                                                setCleared(true);
                                            }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Qualified Items' value={data?.qualified_items || ""} />
                        </Grid> :
                            <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    required
                                    id="qualified_items"
                                    label="Qualified Items"
                                    variant="outlined"
                                    size='small'
                                    margin='normal'
                                    fullWidth
                                    multiline
                                    rows={3}
                                    value={data?.qualified_items || ''}
                                    error={!!error.qualified_items}
                                    helperText={error.qualified_items}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("qualified_items", e.target.value.trimStart()) : e.preventDefault()
                                    }}
                                    disabled={modeType === 'view'}
                                />
                            </Grid>}
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                id="event"
                                label="Event"
                                variant="outlined"
                                size='small'
                                margin='normal'
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 255} }}
                                fullWidth
                                multiline
                                rows={3}
                                value={data?.event || ''}
                                onChange={(e) => {
                                    regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("event", e.target.value.trimStart()) : e.preventDefault()
                                }}
                                disabled={modeType === 'view'}
                            />
                        </Grid>
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Remarks' value={data?.remarks || ""} />
                        </Grid> :
                            <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    id="remarks"
                                    label="Remarks"
                                    variant="outlined"
                                    size='small'
                                    margin='normal'
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    value={data?.remarks || ''}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("remarks", e.target.value.trimStart()) : e.preventDefault()
                                    }}
                                    disabled={modeType === 'view'}
                                />
                            </Grid>}
                        <Grid size={{ md: 12, xs: 12 }} sx={{mt: 3}}>
                             <Box className="responsive-buttons">
                            {data?.id && data?.attachments?.length ?
                                <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({data?.attachments?.length})Attachment(s)</Button> : null
                            }
                             <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                             </Box>
                            {modeType === 'view' ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={data?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' disabled={isLoading} variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null :
                    <Button variant='contained' size='small' className='btn-primary' onClick={() => { handleItemClicked('Save Button'); onAddEditMember() }}>{isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default Qualified_CRU